import React, {Component} from 'react';
import Open from './OpenOrders/open.jsx';
import Unmatched from './OpenOrders/unmatched.jsx';
import MatchedOrders from './MatchedOrders/index.jsx';
import UnlockOrders from './MatchedOrders/unlockable.jsx';

class Bottom extends Component {
  render() {
    return (
      <div id='my_orders' className='col s12' >
        <Open/>
        <MatchedOrders view={'complete'}/>
        <Unmatched/>
        <UnlockOrders/>
      </div>
    )
  }
}

export default Bottom;
